import React from 'react';
import { Link } from 'react-router-dom';
import CleanupLink from './CleanupLink';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <div className="footer-logo mb-3">
                  <img src="/images/logo.png" alt="Grand Indigo" />
                </div>
                <p className="footer-description">
                  At Grand Indigo, we transform concepts into powerful brand experiences. With expertise in digitizing, design, and development, we craft solutions that leave a lasting impression.
                </p>
                <div className="footer-social">
                  <a href="https://www.facebook.com/profile.php?id=61586062061689&sk=directory_links" target='_blank' className="contact-social-link" aria-label="Facebook">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                      </svg>
                  </a>
                  <a href="https://www.instagram.com/grand_indigo_embroidery?igsh=MW5zYWFyajZmb2x3ag==" target='_blank' className="contact-social-link" aria-label="Instagram">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                      </svg>
                  </a>
                  <a href="https://www.linkedin.com/in/grand-indigo-embroidery-digitizing-69779b371/" target='_blank' className="contact-social-link" aria-label="LinkedIn">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                          <circle cx="4" cy="4" r="2" />
                      </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <h4 className="footer-widget-title">Quick Links</h4>
                <ul className="footer-links">
                  <li><CleanupLink to="/">Home</CleanupLink></li>
                  <li><CleanupLink to="/about">About Us</CleanupLink></li>
                  <li><CleanupLink to="/portfolio">Portfolio</CleanupLink></li>
                  <li><CleanupLink to="/pricing">Pricing</CleanupLink></li>
                  <li><CleanupLink to="/contact">Contact Us</CleanupLink></li>
                  <li><CleanupLink to="/careers">Careers</CleanupLink></li>
                </ul>
              </div>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <h4 className="footer-widget-title">Our Services</h4>
                <ul className="footer-links">
                  <li><CleanupLink to="/services/custom-embroidery-digitizing-services">Custom Embroidery Digitizing</CleanupLink></li>
                  <li><CleanupLink to="/services/logo-digitizing-for-embroidery-services">Logo Digitizing for Embroidery</CleanupLink></li>
                  <li><CleanupLink to="/services/cap-hat-digitizing-services">Cap / Hat Digitizing</CleanupLink></li>
                  <li><CleanupLink to="/services/3d-puff-embroidery-digitizing-services">3D Puff Embroidery Digitizing</CleanupLink></li>
                  <li><CleanupLink to="/services/flat-embroidery-digitizing-services">Flat Embroidery Digitizing</CleanupLink></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="footer-widget">
                <h4 className="footer-widget-title">Contact Us</h4>
                <ul className="footer-contact">
                  <li>
                    <a href="tel:(213) 582-4757">(213) 582-4757</a>
                  </li>
                  <li>
                    <a href="mailto:info@grandindigoembroidery.com">info@grandindigoembroidery.com</a>
                  </li>
                  <li>
                    <span>445 S Figueroa St #3187, Los Angeles, CA 90071, United States</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-start">
              <p className="footer-copyright">
                © 2026 <strong>Grand Indigo Digitizing & Vectorizing</strong>. All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6 text-end">
              <p className="footer-copyright">
                <a href="/terms-conditions" className="text-white">Terms & Conditions </a>
                |
                <a href="/privacy-policy" className="text-white"> Privacy Policy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;